import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the tapJobs Redux slice.
 * @returns {Object} Bound action creators: updateJobs, updateJobsSearchForm, clearJobs, clearJobViewModal, clearJobTasksModal
 */
export function useJobsActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
